import { render } from "./Brnews.vue?vue&type=template&id=7e5f203c&scoped=true"
import script from "./Brnews.vue?vue&type=script&lang=js"
export * from "./Brnews.vue?vue&type=script&lang=js"

import "./Brnews.vue?vue&type=style&index=0&id=7e5f203c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7e5f203c"

export default script